// New Varsha Sarees brand mark — bilingual wordmark with the leaf-branch
// motif from the boutique's letterhead, in lavender + champagne.
import { BRAND } from "../../lib/site";

const SIZES = {
  sm: { eng: "text-base", hin: "text-[10px]", branchH: 36, gap: "gap-2.5" },
  md: { eng: "text-[1.65rem] md:text-[2rem]", hin: "text-base md:text-lg", branchH: 60, gap: "gap-3 md:gap-4" },
  lg: { eng: "text-3xl md:text-5xl", hin: "text-lg md:text-2xl", branchH: 96, gap: "gap-4 md:gap-6" },
};

// Leaf branch ornament (re-drawn from the letterhead artwork)
const LeafBranch = ({ height = 52, color = "#7C5FAB", accent = "#C9A961" }) => (
  <svg
    viewBox="0 0 70 120"
    height={height}
    aria-hidden
    className="overflow-visible shrink-0"
  >
    {/* Slim stems */}
    <g stroke={color} strokeWidth="1.2" strokeLinecap="round" fill="none">
      <path d="M14 4 C 18 36, 22 70, 24 116" opacity="0.85" />
      <path d="M22 6 C 28 38, 32 72, 34 110" opacity="0.7" />
      <path d="M30 4 C 36 30, 40 58, 38 100" opacity="0.55" />
      <path d="M38 8 C 44 32, 48 60, 50 112" opacity="0.45" />
    </g>
    {/* Stylised maple-like leaves */}
    <g fill={color}>
      <path d="M12 18 c -6 -2 -10 1 -11 5 c 3 4 9 4 12 1 c 1 -2 1 -4 -1 -6 z" />
      <path d="M22 38 c -7 -3 -11 0 -12 4 c 3 5 10 5 13 1 c 2 -2 1 -4 -1 -5 z" />
      <path d="M30 64 c -7 0 -11 4 -10 8 c 4 4 11 2 12 -2 c 1 -2 0 -4 -2 -6 z" />
      <path d="M40 86 c -7 1 -11 5 -10 9 c 4 4 11 2 12 -3 c 0 -2 0 -4 -2 -6 z" />
      <path d="M44 50 c 0 -7 4 -11 8 -11 c 4 4 3 11 -1 12 c -3 1 -6 1 -7 -1 z" />
    </g>
    {/* Champagne accent dots */}
    <g fill={accent}>
      <circle cx="18" cy="28" r="1.2" />
      <circle cx="28" cy="56" r="1.2" />
      <circle cx="36" cy="78" r="1.2" />
      <circle cx="48" cy="62" r="1.2" />
    </g>
  </svg>
);

export const Logo = ({
  variant = "dark",
  size = "md",
  showHindi = true,
  withBranch = false,
}) => {
  const s = SIZES[size];
  const wordColor = variant === "light" ? "#FCFBF8" : "#2D1F58";
  const accentColor = variant === "light" ? "#C9B6E4" : "#523A87";
  const hindiColor = variant === "light" ? "rgba(252,251,248,0.9)" : "#523A87";
  const branchColor = variant === "light" ? "#C9B6E4" : "#523A87";

  return (
    <div className={`inline-flex items-center ${s.gap}`}>
      {withBranch && (
        <LeafBranch height={s.branchH} color={branchColor} accent={accentColor} />
      )}
      <div className="flex flex-col items-start leading-none">
        <span
          className={`font-serif ${s.eng} tracking-tight whitespace-nowrap`}
          style={{ color: wordColor, fontWeight: 500 }}
        >
          New Varsha{" "}
          <span style={{ color: accentColor }} className="italic">
            Sarees
          </span>
        </span>
        {showHindi && (
          <span
            className={`font-hindi ${s.hin} mt-1.5 tracking-wide`}
            style={{ color: hindiColor, opacity: variant === "light" ? 0.9 : 0.7 }}
          >
            {BRAND.nameHindi}
          </span>
        )}
      </div>
    </div>
  );
};

export default Logo;
